Controller = App.loadClass 'core::Angular/Controller'

class exports.DryingController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service) ->
        super

        @uoms = {}
        @fieldArea = 0

        @dryingSystems =
            'In bin - combination high temperature and air':
                type: 'stirred'
                source: 'Propane, LPG'
            'In bin - natural air/air only':
                type: 'natural'
                source: 'Electricity - Grid'
            'In bin - low temperature':
                type: 'low'
                source: 'Electricity - Grid'
            'In bin - high temperature-air recirculation - continuous flow/mixed flow':
                type: 'recirculating'
                source: 'Propane, LPG'
            'In bin - high temperature layered batch-in-bin or bin with stirring device':
                type: 'recirculating'
                source: 'Propane, LPG'
            'Batch Dryer - high temperature-no air recirculation (Continuous flow dryer)':
                type: 'no-recirculating'
                source: 'Propane, LPG'
            'Batch Dryer - high temperature-no air recirculation (Automatic batch dryer)':
                type: 'no-recirculating'
                source: 'Propane, LPG'
            'Batch Dryer PTO type - high temperature-no air recirculation':
                type: 'no-recirculating'
                source: 'Propane, LPG'
            'Commercially dried by buyer':
                type: 'no-recirculating'
                source: 'Propane, LPG'

        @service.onDataLoaded @scope, () =>
            @http.get "/backend/grower/fieldprint/power-source-uoms/#{@service.crop}"
            .then (response) =>
                @uoms = response.data

            @http.get "/backend/grower/fieldprint/field-area/#{@service.field}"
            .then (response) =>
                @fieldArea = response.data

                # wait for field area to load before watching
                @scope.$watch 'service.fpcResult.data.moisture_difference', () =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.power_source', (newValue, oldValue) =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.dryland_projected', () =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.dryland_actual', () =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.irrigated_projected', () =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.irrigated_actual', () =>
                    @autoSetPowerSourceAmount()

                @scope.$watch 'service.fpcResult.data.drying_system', (newValue, oldValue) =>
                    if newValue? and newValue isnt oldValue
                        @autoSetPowerSource()

                    @autoSetPowerSourceAmount()

        @scope.$watch 'service.fpcResult.data.moisture_difference', (value) =>
            if not value?
                return

            if value > 21
                @service.fpcResult.data.moisture_difference = 21
                return

            if value < 0
                @service.fpcResult.data.moisture_difference = 0
                return

            @service.fpcResult.data.moisture_difference = parseInt(value)

    autoSetPowerSource: () =>
        newPowerSource = @dryingSystems[@service.fpcResult.data.drying_system]?.source

        if newPowerSource
            @service.fpcResult.data.power_source = newPowerSource

    autoSetPowerSourceAmount: () =>
        # don't try to auto calculate a value if a user entered a value manually and the manually entered value has not been cleared
        if @service.fpcResult.data.manual_power_source_amount and @service.fpcResult.data.power_source_amount
            return

        # if the user clears the input we will auto calculate again
        if not @service.fpcResult.data.power_source_amount
            # reset manually enetered power source amount flag
            @service.fpcResult.data.manual_power_source_amount = false
            # perform auto calculation since the user has cleared their manually entered value

        newPowerSourceAmount = @calculatePowerSourceAmount()

        if newPowerSourceAmount
            @service.fpcResult.data.power_source_amount = parseFloat(newPowerSourceAmount.toFixed(2))
        else
            # if we were unable to calculate a power source amount, clear the input
            @service.fpcResult.data.power_source_amount = null


    calculatePowerSourceAmount: () =>
        powerSource = @service.fpcResult.data.power_source
        moistureDifference = @service.fpcResult.data.moisture_difference
        dryingSystemType = @dryingSystems[@service.fpcResult.data.drying_system]?.type

        if @service.fpcResult.data.irrigated
            map = @service.fpcResult.irrigation_map

            if @service.fpcResult.data.yield_to_use is 'projected'
                irrigatedYieldToUse = @service.fpcResult.data.irrigated_projected
                drylandYieldToUse = @service.fpcResult.data.dryland_projected
            else
                irrigatedYieldToUse = @service.fpcResult.data.irrigated_actual
                drylandYieldToUse = @service.fpcResult.data.dryland_actual

            bushels = _(map.areas).filter({ value: 'Irrigated' }).sumBy('acres') * irrigatedYieldToUse
            bushels += _(map.areas).filter({ value: 'Dryland' }).sumBy('acres') * drylandYieldToUse
        else
            bushels = @fieldArea * @service.fpcResult.data.dryland_projected

        if not (powerSource and bushels and moistureDifference)
            return null

        powerIsElectricity = ['Electricity - Grid', 'Electricity - Solar', 'Electricity - Wind'].includes powerSource

        if powerSource isnt 'Propane, LPG' and not powerIsElectricity and powerSource isnt 'Natural Gas'
            return null

        coefficient = switch dryingSystemType
            when 'natural' then switch powerSource
                when 'Propane, LPG' then 0
                when 'Electricity - Grid' then 0.2531
                when 'Electricity - Solar' then 0.2531
                when 'Electricity - Wind' then 0.2531
                else 0
            when 'low' then switch powerSource
                when 'Propane, LPG' then 0.0068
                when 'Electricity - Grid' then 0.1582
                when 'Electricity - Solar' then 0.1582
                when 'Electricity - Wind' then 0.1582
                else null
            when 'stirred' then switch powerSource
                when 'Propane, LPG' then 0.0159
                when 'Electricity - Grid' then 0.0076
                when 'Electricity - Solar' then 0.0076
                when 'Electricity - Wind' then 0.0076
                else null

            # Not used currently, but including for completion
            when 'continuous' then switch powerSource
                when 'Propane, LPG' then 0.0159
                when 'Electricity - Grid' then 0.0076
                when 'Electricity - Solar' then 0.0076
                when 'Electricity - Wind' then 0.0076
                else null

            when 'recirculating' then switch powerSource
                when 'Propane, LPG' then 0.0173
                when 'Electricity - Grid' then 0.0169
                when 'Electricity - Solar' then 0.0169
                when 'Electricity - Wind' then 0.0169
                else 1.6121
            when 'no-recirculating' then switch powerSource
                when 'Propane, LPG' then 0.0221
                when 'Electricity - Grid' then 0.0105
                when 'Electricity - Solar' then 0.0105
                when 'Electricity - Wind' then 0.0105
                else 2.0593

        return coefficient * bushels * moistureDifference
